<template>
	<div class="advertisementManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">广告配置</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop">
				<div class="itemTitleBox disStart">
					<span class="title">首页banner</span>
				</div>
				<div class="disStart listBox">
					<draggable @end="draggableAct" element="ul" :list="bannerList" :animation='200'
						class="disul disBetween">
						<div v-for="(item,inx) in bannerList" :key="inx" class="itemBox" @click="choiceInx=inx">
							<div v-if="item.pictureUrl" class="picBox">
								<img :src="$basImgUrl+item.pictureUrl" class="avatar">
								<span class="linkIcon" @click.stop="linkImg(item,inx)"></span>
								<span class="delIcon" @click.stop="delImg(item,inx,1)"></span>
							</div>
						</div>
					</draggable>
					<el-upload v-if="bannerList.length<5" class="itemBox avatar-uploader disCenter" :data="{
						pictureType: 1,
						pictureIndex: bannerList.length?(bannerList[bannerList.length-1].pictureIndex+1):0
					}" :headers="header" :action="$upUrl+'/projectAdvertisement/addProjectAdvertisement'" :show-file-list="false"
						:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
						+banner图片
					</el-upload>
				</div>

			</div>
			<div class="contentBot disBetween">
				<div class="contentLeft">
					<upLeft></upLeft>
				</div>
				<div class="contentRight">
					<div class="itemTop">
						<upRightT></upRightT>
					</div>
					<div class="itemBot">
						<upRightB></upRightB>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="跳转配置" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem  disStart">
						<!-- <el-radio v-model="creatObj.radio1" label="商品"></el-radio> -->
						<el-checkbox v-model="creatObj.checked1"></el-checkbox>
						<el-form-item class="lableBox" label="商品" prop="name">
							<div class="myinputBox">
								<el-select clearable value-key="value" v-model="creatObj.level" slot="prepend"
									placeholder="请选择商品">
									<el-option v-for="(item,inx) in commodityList" :key="inx" :label="item.text"
										:value="item.value"></el-option>
								</el-select>
							</div>
						</el-form-item>
					</div>
					<div class="diaItem  disStart">
						<el-checkbox v-model="creatObj.checked2"></el-checkbox>
						<el-form-item class="lableBox" label="商家" prop="name">
							<div class="myinputBox">
								<el-select clearable value-key="value" v-model="creatObj.level" slot="prepend"
									placeholder="请选择商家">
									<el-option v-for="(item,inx) in businessList" :key="inx" :label="item.text"
										:value="item.value"></el-option>
								</el-select>
							</div>
						</el-form-item>
					</div>
					<div class="diaItem  disStart">
						<el-radio v-model="creatObj.radio3" label="1">充值</el-radio>
						<el-radio v-model="creatObj.radio3" label="2">商城</el-radio>
					</div>
					<div class="diaItem  disStart">
						<el-checkbox v-model="creatObj.checked5"></el-checkbox>
						<el-form-item class="lableBox" label="链接" prop="name">
							<div class="myinputBox">
								<el-input clearable v-model="creatObj.num" placeholder="">
								</el-input>
							</div>
						</el-form-item>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		Container,
		Draggable
	} from "vue-smooth-dnd";
	import draggable from 'vuedraggable'
	import upLeft from "./upLeft/upLeft.vue"
	import upRightT from "./upRightT/upRightT.vue"
	import upRightB from "./upRightB/upRightB.vue"
	var token = localStorage.getItem('token')
	
	import ajax,{upLoadimg} from '../../../../common/js/ajax.js'
	
	export default {
		name: "advertisementManage",
		components: {
			Container,
			Draggable,
			draggable,
			upLeft,
			upRightT,
			upRightB
		},
		data() {
			return {
				header: {
					Authorization: token,
					token: token
				},
				url:upLoadimg,
				dialogVisible: false,
				NOfalse: false,
				bannerList: [],
				choiceInx: 0,
				creatObj: {},
				rules:[],
				commodityList: [{
						text: "商品1",
						value: "1"
					},
					{
						text: "商品2",
						value: "1"
					},
					{
						text: "商品3",
						value: "1"
					}
				],
				businessList: [{
						text: "商家1",
						value: "1"
					},
					{
						text: "商家2",
						value: "1"
					},
					{
						text: "商家3",
						value: "1"
					}
				],
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getlistProjectAdvertisementByPictureType(1)
			})
		},
		methods: {
			toSave() {},
			linkImg(item, inx) {
				this.dialogVisible = true
			},
			delImg(item, inx, n) {
				this.$api.deleteProjectAdvertisement({
					advertisementId: item.advertisementId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 1) { //删除首页banner
							this.bannerList.splice(inx, 1)
						}
					}
				})
			},
			getData() {},
			draggableAct(dropResult) {
				let obj = {
					advertisementId: this.bannerList[dropResult.newIndex].advertisementId,
					pictureIndex: dropResult.newIndex
				}
				if (dropResult.newIndex == 0) {
					obj.pictureIndex = 0
				} else {
					obj.pictureIndex = this.bannerList[dropResult.newIndex - 1].pictureIndex + 1
				}
				this.$api.updateProjectAdvertisement(obj).then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			// banner上传成功后
			handleAvatarSuccess1(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(1)
			},
			// 获取首页banner图
			getlistProjectAdvertisementByPictureType(n) {
				this.$api.listProjectAdvertisementByPictureType({
					pictureType: n
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "bannerList", res.obj)
					}
				})
			},
			beforeAvatarUpload(file) {
				// console.log(file)
				// const isJPG = file.type === 'image/jpeg';
				// const isLt2M = file.size / 1024 / 1024 < 2;

				// // if (!isJPG) {
				// // 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// // }
				// // if (!isLt2M) {
				// // 	this.$message.error('上传头像图片大小不能超过 2MB!');
				// // }
				// return isJPG && isLt2M;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./advertisementManage.scss";
</style>
